module.exports = __webpack_public_path__ + "img/42_36.89fcd685.png";